import { Avatar, Box, Colors, Icon, Text } from '@factorialco/deprecated-design-system'

import buildUrl from 'modules/core/lib/buildUrl'

import { StampStatus } from 'modules/documents/components/EsignaturePlacementFile/constants'

import './index.styles.css'
const ALERT_ICON_POSITION = '-12px'

interface Props {
  fullName: string
  avatar?: string
  jobTitle?: string
  status: StampStatus
  isPending: boolean
  onRemove?: () => void
  signingOrder?: number
}

const SignerStamp = ({
  fullName,
  avatar,
  jobTitle,
  status,
  isPending,
  onRemove,
  signingOrder,
}: Props) => {
  const borderColor: Record<StampStatus, Colors> = {
    default: 'grey400',
    hover: 'grey600',
    editable: 'grey400',
    error: 'radicalRed1000',
    success: 'grey400',
  }

  return (
    <Box
      position="relative"
      flexDirection="row"
      padding="s8"
      gap="s8"
      border={{ all: { width: 's2', style: 'solid', color: borderColor[status] } }}
      alignItems="center"
      borderRadius={{ all: 'abs008' }}
      background="white"
      width="full"
      height="full"
      cursor="grab"
      className={'SignerStamp_stamp'}
    >
      <Box flexDirection="row" gap="s8" alignItems="center" style={{ flexShrink: '0' }}>
        {signingOrder !== undefined && (
          <Text size="200" weight="semibold" color="darker800">
            {`#${signingOrder}`}
          </Text>
        )}
        {signingOrder === undefined && <Icon.Medium icon="drag-and-drop" />}
        <Box position="relative" width="s32" height="s32">
          <Box
            position="absolute"
            background="grey200"
            borderRadius={{ all: 'abs008' }}
            padding="s4"
          >
            <Icon.Medium icon="signature" />
          </Box>
          <Box
            position="absolute"
            className={status === 'default' && isPending ? 'SignerStamp_avatarStamp' : undefined}
          >
            <Avatar size="s32" url={buildUrl(avatar)} label={fullName} />
          </Box>
        </Box>
      </Box>
      <Box overflowX="hidden">
        <Text size="200" weight="semibold" ellipsis>
          {fullName}
        </Text>
        <Text size="100" ellipsis>
          {jobTitle}
        </Text>
      </Box>
      {(isPending || status === 'error') && (
        <Box
          position="absolute"
          style={{ top: ALERT_ICON_POSITION, right: ALERT_ICON_POSITION }}
          background="grey000White"
        >
          <Icon.Medium
            color={status === 'error' ? 'radicalRed1000' : 'darker800'}
            icon="alert-circle"
          />
        </Box>
      )}
      {status === 'success' && (
        <Box
          position="absolute"
          style={{ top: ALERT_ICON_POSITION, right: ALERT_ICON_POSITION }}
          background="grey000White"
        >
          <Icon.Medium color="lime1000" icon="check-circle" />
        </Box>
      )}
      {status === 'editable' && onRemove && (
        <Box
          position="absolute"
          background="grey000White"
          style={{ top: '2px', right: '2px' }}
          onClick={onRemove}
          cursor="pointer"
        >
          <Icon.Small icon="close" />
        </Box>
      )}
      {status === 'editable' && (
        <Box
          position="absolute"
          background="grey000White"
          style={{ bottom: '-3px', right: '-3px', transform: 'scale(.65)' }}
        >
          <Icon.Medium icon="corner-resize" />
        </Box>
      )}
    </Box>
  )
}

export default SignerStamp
